module.exports = __webpack_public_path__ + "static/thumbnail_sale_desktop-f2e028aed508b60acb8fde3ad45b0650.png";